export type ApiResponseType<T> = {
	code: string;
	data: T;
};

export type OrderingRuleType = {
	id: string;
	desc?: boolean;
};

export type DefaultPropertyType = {
	label: string;
	value: string | number | Array<string | number>;
};

export type DefaultPercentagePropertyType = {
	label: string;
	percentage: number;
};

export type DefaultCountPropertyType = {
	label: string;
	count: string;
};

export type DefaultObjectType = {
	id: string;
	name: string;
};

export type CountryType = {
	country_id: string;
	name: string;
	code: string;
	iso_code: string;
	is_portable: string;
	meta: Array<unknown>;
	status: string;
};

export type ErrorType = 'network' | 'nodata';

export enum ChannelType {
	sms = 'sms',
	// voice = 'voice',
	whatsApp = 'whatsapp',
}

export interface IObjectField {
	name: string;
	value: any;
}

export interface ChannelTypes {
	sms: boolean;
	voice: boolean;
	whatsapp: boolean
}